<template>
  <div class="cs-payment-list">
    <div class="displaytype-normal" v-if="currentDisplayType == 'normal'">
      <div class="cs-payment-list-item" v-for="(item, index) in filterDataModelList" :key="index">
        <div v-if="optionModel.enableRemove" class="close-icon">
          <i v-if="!item.isMemberCard && !item.isChecked" class="el-icon-circle-close"
            @click="onRemoveAccountPayment(index, item)"></i>
        </div>
        <el-card shadow="nerver" class="box-card">
          <i :class="__getEditableClass(index, item)" @click="onPaymentClick(index, item)">
            <el-row>
              <el-col class="cs-payment-list-itemTop">
                <span v-if="!!item.title">{{ item.title }}</span>
                <span v-else>{{ "支付" + (index + 1) }}</span>
                <span v-if="item.isMemberCard">(会员卡)</span>
                <span v-else>&nbsp;</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span class="price-font">{{ item.amount + item.tax | toCurrency(options.currency) }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span class="comment-font cs-color-frenchgrey">{{ !!item.comment ? item.comment : "&nbsp;" }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <i class="paymenttype-icon">
                  <img :src="__getImgSrc(item.paymentTypeId)">
                </i>
              </el-col>
            </el-row>
          </i>
        </el-card>
      </div>
    </div>
    <div class="displaytype-simple" v-if="currentDisplayType == 'simple'">
      <el-row class="cs-payment-list-item" v-for="(item, index) in filterDataModelList" :key="index">
        <el-col v-if="options.isAutonomous">
          <i class="paymenttype-icon">
            <img :src="__getImgSrc(item.paymentTypeId)">
          </i>
          &nbsp;
          <!-- <span>{{item.paymentTypeDescription}}支付</span>
          &nbsp; -->
          <span>{{ item.amount + item.tax + item.serviceCharge | toCurrency(options.currency) }}</span>
          &nbsp;
          <span>{{ item.dateText }}</span>
          <span v-if="item.paymentTypeId == 9 && item.fileId">&nbsp;</span>
          <el-button :loading="isDownloading" v-if="item.paymentTypeId == 9 && item.fileId" type="text" size="medium"
            @click="downloadPaymentFile(item)">查看截图</el-button>
          <span v-if="optionModel.enableEdit">&nbsp;</span>
          <el-button v-if="optionModel.enableEdit" class="edit-button" size="medium" type="text"
            @click="onAutonomousPaymentClick(index, item)">编辑</el-button>
        </el-col>
        <el-col v-else>
          <span>{{ "支付" + (index + 1) }}</span>
          <span v-if="item.isMemberCard">(会员卡)</span>
          &nbsp;
          <span :class="{ 'cs-redLabel': !item.isChecked }">{{ item.amount + item.tax | toCurrency(options.currency) }}</span>
          &nbsp;
          <i class="paymenttype-icon">
            <img :src="__getImgSrc(item.paymentTypeId)">
          </i>
          &nbsp;
          <span :class="{ 'cs-redLabel': !item.isChecked }">{{ item.dateText }}</span>
          &nbsp;
          <span :class="{ 'cs-redLabel': !item.isChecked }"><span
              v-if="options.isAutonomousPaymentWorkflow">(学生自主付款)</span><span v-else>{{ item.userName }}</span></span>
          <span v-if="item.paymentTypeId == 9 && item.fileId">&nbsp;</span>
          <el-button :loading="isDownloading" v-if="item.paymentTypeId == 9 && item.fileId" type="text" size="medium"
            @click="downloadPaymentFile(item)">查看截图</el-button>
          &nbsp;
          <span class="cs-redLabel" v-if="!item.isChecked">(待处理)</span>
          <span class="cs-color-green" v-else>(已核对)</span>

          <el-button
            v-if="optionModel.enableEdit && !item.isMemberCard && !item.isChecked && !options.isAutonomousPaymentWorkflow"
            class="edit-button" size="medium margin-left-10" type="text" @click="onPaymentClick(index, item)">编辑付款</el-button>

          <el-button
            v-if="optionModel.enableEdit"
            class="edit-button" size="medium margin-left-10" type="text" @click="onEidtCommentClick(index, item)">编辑备注</el-button>

          <el-button
            v-if="optionModel.enableRemove && !item.isMemberCard && !item.isChecked && !options.isAutonomousPaymentWorkflow"
            class="edit-button" size="medium margin-left-10" type="text" @click="onRemoveAccountPayment(index, item)">删除</el-button>
        </el-col>
        <el-col v-if="!!item.comment">
          <div class="item-comment" v-html="getComment(item)"></div>
        </el-col>
      </el-row>
    </div>

    <div class="displaytype-simple" v-if="currentDisplayType == 'list'">
      <el-row class="cs-payment-list-item" v-for="(item, index) in filterDataModelList" :key="index">
        <el-col>
          <span>{{ "支付" + (index + 1) }}</span>
          <span v-if="item.isMemberCard">(会员卡)</span>
          &nbsp;
          <span>{{ item.amount + item.tax | toCurrency }}</span>
          &nbsp;
          <i class="paymenttype-icon">
            <img :src="__getImgSrc(item.paymentTypeId)">
          </i>
          &nbsp;
          <span>{{ item.dateText }}</span>
          &nbsp;

          <span>{{ item.userName }}</span>
          &nbsp;
          <el-button v-if="optionModel.enableRemove && !item.isMemberCard && !item.isChecked" class="edit-button"
            size="medium" type="text" @click="onRemoveAccountPayment(index, item)"><i
              class="el-icon el-icon-close delete-row-icon"></i></el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.price-font {
  font-size: 24px;
}

.comment-font {
  font-size: 12px;
}

.cs-payment-list {
  .displaytype-normal {
    .cs-payment-list-item {
      width: 130px;
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      vertical-align: top;

      .cs-payment-list-itemTop {
        span {
          display: block;
        }
      }

      .close-icon {
        position: absolute;
        width: 14px;
        height: 14px;
        margin-left: 124px;
        margin-top: -8px;
        cursor: pointer;

        .el-icon-circle-close:hover {
          color: red;
        }
      }

      .box-card {
        width: 132px;
        background-color: #f5f7fa;
        padding: 0;

        i.editable {
          cursor: pointer;
        }

        .el-col {
          text-align: center;
        }

        .paymenttype-icon {
          padding: 0;
          width: 32px;
          height: 32px;

          img {
            vertical-align: top;
            text-align: left;
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }

  .displaytype-simple {
    .cs-payment-list-item {
      line-height: 20px;
      padding: 5px 0px 5px 0px;

      .paymenttype-icon {
        padding: 0;
        width: 32px;
        height: 32px;

        img {
          display: inline-block;
          width: 20px;
          margin-right: 5px;
          margin-left: 5px;
        }
      }

      .edit-button {
        padding: 0px;
      }

      .item-comment {
        background: whitesmoke;
        color: grey;
        padding: 5px 0;
        line-height: 23px;
        min-height: 55px;
      }
    }
  }
}
</style>

<script>
import global_ from "@/core/global";

import { getPaymentImgList, downloadFile } from "../../config/mUtils.js";
import { getPaymentTypes } from "../../service/finance.service.js";
import { getBlobFileUrlById, downloadFileToBlob } from "@/service/blobStorage.service";

export default {
  props: {
    dataList: {
      type: Array,
      required: true
    },
    options: {
      displayType: {
        type: String,
        validator: (value) => ["normal", "simple", "list"].contains(value),
      },
      enableEdit: Boolean,
      enableRemove: Boolean,
      paymentTypes: Array,
      currency: {
        type: Number,
        default: global_.currencyType.CAD
      },
      isAutonomous: Boolean,
      isAutonomousPaymentWorkflow: Boolean,

    }
  },
  data: function () {
    return {
      displayTypes: ["normal", "simple", "list"],
      paymentImgList: {},
      paymentTypes: [],
      dataModelList: [],
      optionModel: {
        enableEdit: false,
        enableRemove: false
      },
      isDownloading: false,
    };
  },
  components: {},
  computed: {
    currentDisplayType: function () {
      let result = "normal";

      if (!!this.options.displayType) {
        for (let i = 0; i < this.displayTypes.length; i++) {
          if (this.displayTypes[i] == this.options.displayType.toLowerCase()) {
            result = this.displayTypes[i];
            break;
          }
        }
      }

      return result;
    },
    filterDataModelList: function () {
      let filterList = this.dataModelList.filter(function (item, index) {
        item.originalIndex = index;
        return item.enable;
      });
      return filterList;
    }
  },
  created() {
    this.initBasicData();
    this.reset();
  },
  updated() { },
  methods: {
    async initBasicData() {
      this.paymentImgList = getPaymentImgList();
      //await this.loadPaymentTypes();
    },
    reset() {
      this.reloadOptionModel();
      this.reloadDataModelList();
    },
    async loadPaymentTypes() {
      let result = await getPaymentTypes(true, false);
      if (!!result && result.success) {
        this.paymentTypes = result.data;
      }
      else this.paymentTypes = [];
    },
    reloadOptionModel(options) {
      if (!options) options = this.options;

      if (!!options) {
        this.optionModel.enableEdit = !!options.enableEdit;
        this.optionModel.enableRemove = !!options.enableRemove;
        if (!!this.options.paymentTypes) {
          this.paymentTypes = this.options.paymentTypes;
        } else {
          this.loadPaymentTypes();
        }

        let credits = this.paymentTypes.find(i => i.Name == "credits");
        if (this.paymentTypes.length == 2 && credits) {
          this.paymentImgList = {
            credits: require("@/assets/payment-credits.png"),
            balance: require("@/assets/payment-balance.png"),
          };
        } else {
          this.paymentImgList = getPaymentImgList();
        }

      } else {
        this.optionModel.enableEdit = false;
        this.optionModel.enableRemove = false;
      }
    },
    reloadDataModelList(dataList) {
      if (!dataList) dataList = this.dataList;

      this.__setToDataModelList(dataList);
    },

    onRemoveAccountPayment(index, item) {

      this.$confirm("您确定要删除该笔支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = this.__convertToDataOut(item);
        this.$emit("item-remove", {
          index: item.originalIndex,
          item: data
        });
      }).catch(() => { });;
    },
    onPaymentClick(index, item) {
      if (!this.optionModel.enableEdit || item.isMemberCard || item.isChecked)
        return;

      let data = this.__convertToDataOut(item);
      this.$emit("item-click", {
        index: item.originalIndex,
        item: data,
        isAutonomous: false,
        isEditComment: false
      });
    },
    onEidtCommentClick(index, item){
      if (!this.optionModel.enableEdit)
        return;

      let data = this.__convertToDataOut(item);
      this.$emit("item-click", {
        index: item.originalIndex,
        item: data,
        isAutonomous: false,
        isEditComment: true
      });
    },
    onAutonomousPaymentClick(index, item) {
      if (!this.optionModel.enableEdit)
        return;
      let data = this.__convertToDataOut(item);
      this.$emit("item-click", {
        index: item.originalIndex,
        item: data,
        isAutonomous: true,
        isEditComment: false
      });
    },
    __findPaymentType(typeId) {
      let result = null;
      for (let i = 0; i < this.paymentTypes.length; i++) {
        let type = this.paymentTypes[i];
        if (type.Id == typeId) {
          result = type;
          break;
        }
      }
      return result;
    },
    __getImgSrc(typeId) {
      let paymentType = this.__findPaymentType(typeId);
      if (paymentType == null) {
        return null;
      }

      return this.paymentImgList[paymentType.Name];
    },
    __getEditableClass(index, item) {
      let editableClass = "";

      if (
        this.optionModel.enableEdit &&
        !item.isMemberCard &&
        !item.isChecked
      ) {
        editableClass = "editable";
      }

      return editableClass;
    },
    __setToDataModelList(dataList) {
      let dataModelList = [];

      if (!!dataList && dataList.length > 0) {
        for (let i = 0; i < dataList.length; i++) {
          let data = dataList[i];
          let fileId = 0;
          if (data.ImageFiles && data.ImageFiles.length > 0) {
            fileId = data.ImageFiles[0].FileStorageId;
          }
          dataModelList.push({
            id: data.Id,
            accountId: data.AccountId,
            paymentTypeId: data.PaymentTypeId,
            paymentTypeDescription: data.PaymentTypeDescription,
            serviceCharge: data.ServiceCharge,
            tax: data.Tax,
            amount: data.Amount,
            comment: data.Comment,
            isChecked: data.IsChecked,
            isMemberCard: data.IsMemberCard,
            enable: data.Enable,
            dateText: data.DateText,
            userName: data.UserName,
            name: data.Name,
            email: data.Email,
            title: data.Title,
            fileId: fileId,
            imageFiles: data.ImageFiles
          });
        }
      }
      this.dataModelList = dataModelList;
    },
    __convertToDataOut(dataModel) {
      let data = {};

      if (!!dataModel) {
        $.extend(true, data, {
          Id: dataModel.id,
          AccountId: dataModel.accountId,
          PaymentTypeId: dataModel.paymentTypeId,
          ServiceCharge: dataModel.serviceCharge,
          Tax: dataModel.tax,
          Amount: dataModel.amount,
          Comment: dataModel.comment,
          IsChecked: dataModel.isChecked,
          IsMemberCard: dataModel.isMemberCard,
          Enable: dataModel.enable,
          DateText: dataModel.dateText,
          UserName: dataModel.userName,
          Name: dataModel.name,
          Email: dataModel.email,
          ImageFiles: dataModel.imageFiles,
        });
      }

      return data;
    },
    downloadPaymentFile(item) {
      this.isDownloading = true;

      if (item.imageFiles && item.imageFiles.length > 0) {
        for (let i = 0; i < item.imageFiles.length; i++) {
          let fileId = item.imageFiles[i].FileStorageId;
          getBlobFileUrlById(fileId)
            .then((result) => {
              if (!!result && result.success) {
                let { Url, FileName } = result.data;

                downloadFileToBlob(Url, 0).then((res) => {
                  downloadFile({ data: res.data, filename: FileName }, true);
                  this.isDownloading = false;
                });

              } else {
                if (!!result.message) {
                  this.$message.error(result.message);
                }
                this.isDownloading = false;
              }
            })
            .catch(() => { });
        }
      }
    },
    getComment(item) {
      if (item.paymentTypeId == 9) {
        let comment = "";
        if (item.name) {
          comment = "姓名: " + item.name;
        }
        if (item.email) {
          comment += "<br/>邮箱: " + item.email;
        }
        if (item.comment) {
          comment += "<br/>备注: " + item.comment;
        }
        return comment;
      } else {
        return item.comment;
      }
    }
  },
  watch: {
    dataList: function (newVal) {
      this.reloadDataModelList(newVal);
    },
    options: function (newVal) {
      this.reloadOptionModel(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paymentListView.vue